"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const sleep_1 = __importDefault(require("./sleep"));
async function timeout(target, ms) {
    return Promise.race([
        target,
        (async () => {
            await sleep_1.default(ms);
            // TODO: Figure out how to print function name
            throw new Error(`Function has timed out with the limit of ${ms} milliseconds.`);
        })(),
    ]);
}
exports.default = timeout;
//# sourceMappingURL=timeout.js.map